// modules
import { createAction } from 'redux-actions'

export const setProviderList = createAction('SET_PROVIDER_LIST')

export const resetProviderManagement = createAction('RESET_PROVIDER_MANAGEMENT')
